import { Text } from './Text';

// TODO: in v9, move styled() from Text.jsx to here
export var StyledText = Text;